export default __webpack_public_path__ + "static/media/utility.299d749a.svg";